
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import UserProfileCard from "@/components/profile/UserProfileCard";
import UserPostsSection from "@/components/profile/UserPostsSection";
import UserCommentsSection from "@/components/profile/UserCommentsSection";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const Profile = () => {
  const { user, userProfile, loading } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("profile");
  
  useEffect(() => {
    if (!loading && !user) {
      navigate("/login");
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <Layout>
        <div className="container mx-auto py-10 flex justify-center items-center min-h-[50vh]">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="container mx-auto py-10">
        <h1 className="text-3xl font-bold mb-6">내 프로필</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-1">
            {user && userProfile && (
              <UserProfileCard user={user} userProfile={userProfile} />
            )}
          </div>
          
          <div className="md:col-span-2">
            <Tabs 
              value={activeTab} 
              onValueChange={setActiveTab}
              className="w-full"
            >
              <TabsList className="grid grid-cols-3 mb-6">
                <TabsTrigger value="profile">기본 정보</TabsTrigger>
                <TabsTrigger value="posts">내가 쓴 글</TabsTrigger>
                <TabsTrigger value="comments">내가 쓴 댓글</TabsTrigger>
              </TabsList>
              
              <TabsContent value="profile">
                <Card>
                  <CardHeader>
                    <CardTitle>사용자 정보</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-4">
                      <div>
                        <p className="text-sm font-medium text-muted-foreground">이메일</p>
                        <p className="text-lg">{user?.email}</p>
                      </div>
                      
                      <div>
                        <p className="text-sm font-medium text-muted-foreground">사용자 이름</p>
                        <p className="text-lg">{userProfile?.username || "이름 미설정"}</p>
                      </div>
                      
                      {userProfile?.bio && (
                        <div>
                          <p className="text-sm font-medium text-muted-foreground">소개</p>
                          <p className="text-lg">{userProfile.bio}</p>
                        </div>
                      )}
                    </div>
                  </CardContent>
                </Card>
              </TabsContent>
              
              <TabsContent value="posts">
                {user && <UserPostsSection userId={user.id} />}
              </TabsContent>
              
              <TabsContent value="comments">
                {user && <UserCommentsSection userId={user.id} />}
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
